<template>
  <div class="animate__animated animate__rotateInDownLeft" id="documentation">
    <Main/>
  </div>
</template>

<script>
import Main from '@/components/doc/Main.vue'

export default {
  components: {
    Main
  }
}
</script>

<style>

</style>
